import React from 'react'
import '../../LoadingSpinner.css'
import { usePromiseTracker } from "react-promise-tracker";

const LoadingSpinner = (props) => {
    const { promiseInProgress } = usePromiseTracker({ area: props.area, delay: 0 })
    //console.log("LoadingSpinner ", props, promiseInProgress)
    return (
        promiseInProgress && 
        <div className="loading">
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
            <text>{props.task}</text>
        </div>
    )
}

export default LoadingSpinner